import React from 'react';
import Clock from '../../../../../assets/icons/Clock.svg';
import file from '../../../../../assets/icons/file.svg';
import user from '../../../../../assets/icons/user.svg';
import page from '../../../../../assets/icons/page.svg';
import payment from '../../../../../assets/icons/payment.svg';
import report from '../../../../../assets/icons/report.svg';

const helps = [
  {
    icon: Clock,
    title: 'Individual Scheduling',
    desc: 'Quickly share your availability and let others book time with you—simple, fast, and stress-free.',
    color: '#EBF5FF',
    iconColor: '#0C4767',
  },
  {
    icon: file,
    title: 'Auto-Assigned Meetings',
    desc: 'Let MeetOcto automatically assign meetings based on availability—no more guessing or double-booking.',
    color: '#FFF7ED',
    iconColor: '#FD9926',
  },
  {
    icon: user,
    title: 'Team Member Selection',
    desc: 'Easily pick the right team members for each meeting. MeetOcto makes sure the right people are in the loop.',
    color: '#F0FDF4',
    iconColor: '#45C48A',
  },
  {
    icon: page,
    title: 'Team-Wide Pages',
    desc: 'Keep everyone on the same page with shared schedules and team info—all in one easy-to-access spot.',
    color: '#F5F3FF',
    iconColor: '#7C3AED',
  },
  {
    icon: payment,
    title: 'Centralized Billing',
    desc: "Manage all your team's payments in one place—simple, clear, and hassle-free.",
    color: '#FFF0F6',
    iconColor: '#DB2777',
  },
  {
    icon: report,
    title: 'Metrics & Reporting',
    desc: 'Get a clear view of your meetings and team performance with easy-to-read reports—no spreadsheets required.',
    color: '#FFFBEB',
    iconColor: '#D97706',
  },
];

export const HelpSectionView = () => {
  return (
    <section id="meetocto-for" className="help-section">
      <div className="help-section__inner">
        <div className="help-section__header">
          <span className="help-section__label">Everything You Need</span>
          <h2 className="help-section__title">MeetOcto Can Help You</h2>
          <p className="help-section__subtitle">
            Powerful tools for individuals and teams—streamline scheduling, payments, and collaboration in one place.
          </p>
        </div>
        <div className="help-section__grid">
          {helps.map((item, index) => (
            <div className="help-card" key={index}>
              <div className="help-card__icon-wrap" style={{ backgroundColor: item.color }}>
                <img src={item.icon} alt={item.title} className="help-card__icon" style={{ filter: getFilter(item.iconColor) }} />
              </div>
              <h3 className="help-card__title">{item.title}</h3>
              <p className="help-card__desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

function getFilter(hex) {
  const filters = {
    '#0C4767': 'invert(20%) sepia(60%) saturate(800%) hue-rotate(180deg)',
    '#FD9926': 'invert(62%) sepia(80%) saturate(600%) hue-rotate(10deg)',
    '#45C48A': 'invert(60%) sepia(50%) saturate(500%) hue-rotate(110deg)',
    '#7C3AED': 'invert(30%) sepia(80%) saturate(800%) hue-rotate(240deg)',
    '#DB2777': 'invert(30%) sepia(80%) saturate(800%) hue-rotate(300deg)',
    '#D97706': 'invert(55%) sepia(70%) saturate(600%) hue-rotate(20deg)',
  };
  return filters[hex] || 'none';
}
